export interface Truck {
  id?: number;
  registrationNumber: string;
  engineNumber?: string | null;
  chasisNumber?: string | null;
  transporterId?: number;
  model: string;
  make: string;
  year: number;
  capacity: number;
  capacityUnit: string;
  fuelType: string;
  insuranceExpiryDate: number;
  permitExpiryDate: number;
  fitnessExpiryDate: number;
  pucExpiryDate: number | null;
  trailerType: TrailerType;
  containerType: ContainerType;
  status: TruckStatus;
  createdDate?: string;
  updatedDate?: string;
}

export enum FuelType {
  GASOLINE = "GASOLINE",
  EV = "EV",
}

export enum TruckStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  MAINTENANCE = "MAINTENANCE",
  RETIRED = "RETIRED",
}

export enum TrailerType {
  DOUBLE_TWENTY = "DOUBLE_TWENTY",
  SINGLE_TWENTY = "SINGLE_TWENTY",
  OPEN_TANK = "OPEN_TANK",
  FLAT_RACK = "FLAT_RACK",
}

export enum ContainerType {
  HQ = "HQ",
  OT = "OT",
  FL = "FL",
  GP = "GP",
  RF = "RF",
  HD = "HD",
  DV = "DV",
  TK = "TK",
}

export interface TruckListResponse {
  message: string;
  error: boolean;
  data: {
    links: Array<{
      rel: string;
      href: string;
    }>;
    content: Truck[];
    page: {
      size: number;
      totalElements: number;
      totalPages: number;
      number: number;
    };
  };
}

export interface TruckFilters {
  transporterId?: number;
  status?: TruckStatus;
  search?: string;
  skip?: number;
  limit?: number;
}

export interface CreateTruckRequest {
  registrationNumber: string;
  engineNumber?: string | null;
  chasisNumber?: string | null;
  transporterId?: number;
  model: string;
  make: string;
  year: number;
  capacity: number;
  capacityUnit: string;
  fuelType: FuelType;
  insuranceExpiryDate: number;
  permitExpiryDate: number;
  fitnessExpiryDate: number;
  pucExpiryDate: number | null;
  trailerType: TrailerType;
  containerType: ContainerType;
  status?: TruckStatus;
}

export interface UpdateTruckRequest extends CreateTruckRequest {
  id: number;
}
